<!-- Exiting scss 'consent-info-old' with feature flag. Should be removed when third party consent feature is fully implemented -->
<div [ngClass]="{ 'consent-info': thirdPartyConsentActive, 'consent-info-old': !thirdPartyConsentActive }">
    <div class="d-flex">
      <div [appDisableInput]="caseStateService.isCaseDisabled()" >
        @if (selectedCaseConsentData?.includeConsent) {
          <div class="consent-main">
            <app-drop-down-consent
              [loading]="consentRequestLoading"
              [items]="consentData"
              [(selectedItemId)]="selectedConsent"
              (selectedItemIdChange)="onSelectItem($event)"
              (open)="onOpen()"
              #dropDownConsentInstance>
            </app-drop-down-consent>
          </div>
        } @else {
          <div class="consent-main">
          </div>
        }
      </div>
        @if(thirdPartyConsentActive){
          <div class="third-consent-main" >
            <app-drop-down-third-party-consent
              [loading]="false"
              [itemsThird]="thirdPartyConsentData"
              [(selectedItemId)]="selectedThirdPartyConsent"
              (selectedItemIdChange)="onSelectThirdPartyConsentItem($event)"
              (open)="onThirdOpen()"
              [stakeholderName]="stakeholderName"
              [stakeholderRemark]="stakeholderRemark"
              #dropDownThirdConsentInstance>
            </app-drop-down-third-party-consent>
          </div>
        }
    </div>
</div>
